// extracted by mini-css-extract-plugin
module.exports = {"black":"ShoppingCartIcon_black__Fprda","white":"ShoppingCartIcon_white__faVEU","svg":"ShoppingCartIcon_svg__Yt2hE"};